// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KwO4","largestCol":"styles_largestCol__2kvC1","smallestCol":"styles_smallestCol__rcTe2"};